var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { attrs: { "align-v": "center" } },
        [
          _vm.revendedoraSelecionada
            ? _c("b-col", { staticClass: "col-md-6" }, [
                _c("h4", [_vm._v(_vm._s(_vm.revendedoraSelecionada.label))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              !_vm.isBonificacao && !_vm.cash_back
                ? _c(
                    "b-button",
                    {
                      staticClass: "md-3 mr-3",
                      attrs: {
                        disabled: _vm.kitP,
                        size: "sm",
                        variant: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.selecionaRevendedora()
                        }
                      }
                    },
                    [_vm._v("Selecionar Revendedora")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.hover.top",
                      value: "Importar Arquivo",
                      expression: "'Importar Arquivo'",
                      modifiers: { hover: true, top: true }
                    }
                  ],
                  attrs: {
                    disabled: _vm.kitP,
                    variant: "outline-primary",
                    size: "sm"
                  },
                  on: { click: _vm.showModalFileUpload }
                },
                [_c("i", { staticClass: "fas fa-upload" })]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.hover.top",
                      value: "Aproveitar Todo estoque",
                      expression: "'Aproveitar Todo estoque'",
                      modifiers: { hover: true, top: true }
                    }
                  ],
                  attrs: {
                    disabled: _vm.kitP,
                    variant: "outline-primary",
                    size: "sm"
                  },
                  on: { click: _vm.aproveitarTodoEstoque }
                },
                [_c("i", { staticClass: "fas fa-box-open" })]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.hover.top",
                      value: "Limpar uso do Estoque",
                      expression: "'Limpar uso do Estoque'",
                      modifiers: { hover: true, top: true }
                    }
                  ],
                  attrs: {
                    disabled: _vm.kitP,
                    variant: "outline-primary",
                    size: "sm"
                  },
                  on: { click: _vm.limparUsoEstoque }
                },
                [_c("i", { staticClass: "fas fa-broom" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mb-2", attrs: { "align-v": "end" } },
        [
          _c("b-col", { staticClass: "col-md-2" }, [
            _vm.classe !== "H"
              ? _c(
                  "div",
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(" Desconto % ")
                    ]),
                    _vm._v(" "),
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "###",
                          expression: "'###'"
                        }
                      ],
                      attrs: { disabled: _vm.kitP, placeholder: "Desconto" },
                      model: {
                        value: _vm.descontoDoPedido,
                        callback: function($$v) {
                          _vm.descontoDoPedido = $$v
                        },
                        expression: "descontoDoPedido"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "text-right",
              attrs: { "align-h": "right", "align-self": "end" }
            },
            [
              _c(
                "b-list-group",
                { attrs: { horizontal: "" } },
                [
                  _c(
                    "b-list-group-item",
                    { staticClass: "text-center", attrs: { variant: "light" } },
                    [
                      _c("i", { staticClass: "fas fa-cart-plus" }),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _vm._v("Itens "),
                          _c("b-badge", { attrs: { variant: "info" } }, [
                            _vm._v(" " + _vm._s(_vm.qtdItens) + " ")
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group-item",
                    { staticClass: "text-center", attrs: { variant: "light" } },
                    [
                      _c("i", { staticClass: "fas fa-cart-plus" }),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _vm._v("Produtos\n            "),
                          _c("b-badge", { attrs: { variant: "info" } }, [
                            _vm._v(_vm._s(_vm.qtdProdutos))
                          ])
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group-item",
                    {
                      staticClass: "text-center",
                      attrs: { variant: "primary" }
                    },
                    [
                      _c("i", { staticClass: "far fa-money-bill-alt" }),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _vm._v("\n            Total "),
                          _c("b-badge", { attrs: { variant: "info" } }, [
                            _vm._v("R$ " + _vm._s(_vm.valorTotal))
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.kitP
            ? _c("b-col", { staticClass: "text-right" }, [
                _c("h3", [_vm._v("Pedido Kit Personalizado!")])
              ])
            : _vm.isBonificacao
            ? _c("b-col", { staticClass: "text-right" }, [
                _c("h3", [_vm._v("Pedido Bonificado")])
              ])
            : _vm.cash_back && _vm.cash_back.id
            ? _c(
                "b-col",
                { staticClass: "text-right bg-danger pedido-cash mr-2" },
                [
                  _c("h5", { staticClass: "mt-1 mr-1" }, [
                    _vm._v(
                      "\n        Pedido CashBack no valor de R$\n        " +
                        _vm._s(
                          _vm.cash_back.cashback.toString().replace(".", ",")
                        ) +
                        "\n      "
                    )
                  ])
                ]
              )
            : _vm.pedidoEstoque
            ? _c(
                "b-col",
                { staticClass: "text-right bg-danger pedido-cash mr-2" },
                [
                  _c("h5", { staticClass: "mt-1 mr-1" }, [
                    _vm._v("\n        Pedido de Estoque\n      ")
                  ])
                ]
              )
            : _vm.pedidoLancamento
            ? _c(
                "b-col",
                { staticClass: "text-right bg-danger pedido-cash mr-2" },
                [
                  _c("h5", { staticClass: "mt-1 mr-1" }, [
                    _vm._v("\n        Pedido de Lançamento\n      ")
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card border border-primary" }, [
            _c("div", { staticClass: "d-flex justify-content-center mt-3" }, [
              _vm.loading
                ? _c("div", {
                    staticClass: "spinner-border text-primary",
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { role: "status" }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loading,
                    expression: "!loading"
                  }
                ],
                staticClass: "card-body"
              },
              [
                _c(
                  "b-row",
                  { attrs: { "align-v": "end" } },
                  [
                    _c("b-col", { attrs: { cols: "4" } }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Produto")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.codigo,
                            expression: "codigo"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "input-codigo-produto", type: "number" },
                        domProps: { value: _vm.codigo },
                        on: {
                          keyup: [
                            _vm.searchProduto,
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.changeFocusCodigo.apply(
                                null,
                                arguments
                              )
                            }
                          ],
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.codigo = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "2" } }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Quantidade")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "######",
                            expression: "'######'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quantidade,
                            expression: "quantidade"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "input-quantidade", type: "text" },
                        domProps: { value: _vm.quantidade },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.addPedido.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.quantidade = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.getEstoqueDisponivel > 0 && !_vm.cash_back
                      ? _c("b-col", { attrs: { cols: "2" } }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Usar do Estoque")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "####",
                                expression: "'####'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.usarEstoque,
                                expression: "usarEstoque"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", min: "0" },
                            domProps: { value: _vm.usarEstoque },
                            on: {
                              keyup: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.addPedido.apply(null, arguments)
                                },
                                _vm.keyUpValidateEstoque
                              ],
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.usarEstoque = $event.target.value
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "align-buttom",
                            attrs: { variant: "success" },
                            on: { click: _vm.addPedido }
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(" Adicionar\n              ")
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        class: [
                          _vm.getEstoqueDisponivel > 0
                            ? "col-md-6 col-sm-12"
                            : "col-12"
                        ]
                      },
                      [
                        _c("small", [
                          _c("p", { staticClass: "text-info" }, [
                            _c("b", [_vm._v(" " + _vm._s(_vm.labelProduto))])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.getEstoqueDisponivel > 0
                      ? _c("b-col", [
                          _vm.getEstoqueDisponivel > 0
                            ? _c("div", [
                                _c("small", { staticClass: "text-primary" }, [
                                  _vm._v(
                                    "\n                  Estoque: " +
                                      _vm._s(_vm.getEstoqueDisponivel) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("h5")
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12",
                      staticStyle: { overflow: "auto" }
                    },
                    [
                      _c(
                        "b-table-simple",
                        {
                          attrs: {
                            "caption-top": "",
                            hover: "",
                            small: "",
                            stacked: "sm"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "table-caption",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _vm._v(
                                        "\n                    Aproveitamento do estoque\n                    "
                                      ),
                                      _c(
                                        "b-badge",
                                        { attrs: { variant: "info" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.qtdAproveitadoEstoque)
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.pedidoMinimo
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              "O Valor do pedido mínimo é de R$ " +
                                                parseFloat(
                                                  _vm.pedidoMinimo.valor
                                                )
                                                  .toFixed(2)
                                                  .toString()
                                                  .replace(".", ",")
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-thead",
                            { attrs: { "head-variant": "light" } },
                            [
                              _c(
                                "b-tr",
                                [
                                  _c("b-th", { staticClass: "text-center" }, [
                                    _vm._v("Código")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [_vm._v("Produto")]),
                                  _vm._v(" "),
                                  _vm.classe === "H"
                                    ? _c(
                                        "b-th",
                                        { staticClass: "text-center" },
                                        [
                                          _vm._v(
                                            "\n                      Desconto\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-th", { staticClass: "text-center" }, [
                                    _vm._v("Preço R$")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", { staticClass: "text-center" }, [
                                    _vm._v("Qtd")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", { staticClass: "text-center" }, [
                                    _vm._v("Estoque Disp.")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", { staticClass: "text-center" }, [
                                    _vm._v("Uso Estoque")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", { staticClass: "text-center" }, [
                                    _vm._v("Total")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [_vm._v(" ")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(_vm.pedidosOrdered, function(pedido, index) {
                              return _c(
                                "b-tr",
                                {
                                  key: index,
                                  class: { "first-row": index === 0 }
                                },
                                [
                                  _c(
                                    "b-td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { "stacked-heading": "codigo" }
                                    },
                                    [_vm._v(_vm._s(pedido.codigo))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    { attrs: { "stacked-heading": "Produto" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.produtos[pedido.codigo].nome)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.classe === "H"
                                    ? _c(
                                        "b-td",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            "stacked-heading": "desconto"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                parseFloat(
                                                  _vm.produtos[pedido.codigo]
                                                    .desconto
                                                )
                                                  .toFixed(2)
                                                  .replace(".", ",")
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { "stacked-heading": "Preço" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            parseFloat(
                                              _vm.produtos[pedido.codigo].preco
                                            )
                                              .toFixed(2)
                                              .replace(".", ",")
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { "stacked-heading": "Qtd" }
                                    },
                                    [_vm._v(_vm._s(pedido.quantidade))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        "stacked-heading": "Estoque Disp."
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.estoqueDisponivelComputed[
                                              pedido.codigo
                                            ]
                                              ? _vm.estoqueDisponivelComputed[
                                                  pedido.codigo
                                                ]
                                              : ""
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        "stacked-heading": "Uso Estoque"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(pedido.aproveitadoEstoque) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { "stacked-heading": "Total" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            parseFloat(
                                              parseFloat(
                                                _vm.produtos[pedido.codigo]
                                                  .preco -
                                                  _vm.produtos[pedido.codigo]
                                                    .desconto
                                              ) * pedido.quantidade
                                            )
                                              .toFixed(2)
                                              .replace(".", ",")
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-td",
                                    { staticClass: "text-center" },
                                    [
                                      _vm.showEditar(pedido.codigo)
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                title: "Editar",
                                                variant: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showModalEdit(
                                                    pedido.codigo
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-edit"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            title: "Deletar",
                                            variant: "outline-danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.showDeleteItem(
                                                pedido.codigo
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-trash-alt"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _vm.getIdPedido > 0
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            on: { click: _vm.showModalDestroyPedido }
                          },
                          [
                            _c("i", { staticClass: "fas fa-trash-alt" }),
                            _vm._v(" Deletar\n              ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.profile.pdf
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.savePedido.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-save" }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.kitP ? "Salvar e Enviar " : "Salvar"
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            centered: "",
            "no-close-on-backdrop": "",
            "hide-header": "",
            "no-close-on-esc": "",
            "no-enforce-focus": "",
            "no-stacking": ""
          },
          model: {
            value: _vm.modalRevendedora,
            callback: function($$v) {
              _vm.modalRevendedora = $$v
            },
            expression: "modalRevendedora"
          }
        },
        [
          _c("label", [_vm._v("Selecione a Revendedora:")]),
          _vm._v(" "),
          _c("b-form-input", {
            class: ["text-left"],
            attrs: {
              placeholder: "Digite o nome do revendedor(a)",
              autocomplete: "off"
            },
            on: {
              blur: function($event) {
                _vm.visibleResult = false
              },
              focus: function($event) {
                _vm.visibleResult = true
              }
            },
            model: {
              value: _vm.searchRevendedora,
              callback: function($$v) {
                _vm.searchRevendedora = $$v
              },
              expression: "searchRevendedora"
            }
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleResult,
                    expression: "visibleResult"
                  }
                ],
                staticClass: "search-result text-center border rounded shadow"
              },
              [
                _vm._l(_vm.ObjListaDeRevendedoras, function(
                  revendedora,
                  index
                ) {
                  return _c(
                    "b-row",
                    {
                      key: index,
                      class: [
                        "py-2",
                        "m-0",
                        "result-list",
                        index + 1 != _vm.ObjListaDeRevendedoras.length
                          ? "border-bottom"
                          : ""
                      ],
                      on: {
                        click: function($event) {
                          return _vm.changeRevendedora(revendedora)
                        }
                      }
                    },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "product-name text-left",
                          attrs: { cols: "10" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.capitalize(revendedora.label)) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.loadingRevenda
                  ? _c(
                      "div",
                      _vm._l(5, function(load) {
                        return _c(
                          "b-row",
                          {
                            key: load,
                            class: [
                              "py-2",
                              "m-0",
                              load != 5 ? "border-bottom" : "",
                              "justify-content-center"
                            ]
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "bressay-bold-italic product-name p-0 d-flex justify-content-start align-items-center"
                              },
                              [
                                _c("b-skeleton", {
                                  staticClass: "ml-3",
                                  attrs: {
                                    animation: "wave",
                                    width: _vm.numeroAleatorio(40, 60) + "%"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm.ObjListaDeRevendedoras.length == 0
                  ? _c(
                      "p",
                      {
                        staticClass: "py-2 m-0",
                        staticStyle: { "font-size": "16px" }
                      },
                      [_vm._v("Nenhum revendedora(a) encontrado!")]
                    )
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.classe === "G" && !_vm.valido
            ? _c(
                "b-alert",
                {
                  staticClass: "mt-3",
                  attrs: { show: "", variant: _vm.cpfIsValid }
                },
                [
                  _vm._v(
                    "\n      CPF da revendedora é inválido, por favor corrija o CPF antes de prosseguir.\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { variant: "danger" },
              on: { click: _vm.goBack }
            },
            [
              _vm._v("\n      Cancelar "),
              _c("i", { staticClass: "fas fa-times" })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.saveRevendedora }
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _vm._v(" Salvar\n      ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.isCadastro = false
                        }
                      }
                    },
                    [_vm._v("\n        cancelar\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.isCadastro,
            callback: function($$v) {
              _vm.isCadastro = $$v
            },
            expression: "isCadastro"
          }
        },
        [
          _vm.profile.endereco
            ? _c(
                "b-card",
                [
                  _c("cadastro-revendedora", {
                    attrs: {
                      disabled: _vm.kitP,
                      lista_revendedoras: _vm.revendedoras,
                      revendedora: {},
                      classe_distribuidor: _vm.classe,
                      meu_estado: _vm.profile.endereco.cidade.estado.uf
                        ? _vm.profile.endereco.cidade.estado.uf
                        : ""
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "exampleModalLabel" }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.labelProduto) + "\n      "
                      )
                    ]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success", size: "sm" },
                      on: { click: _vm.updatePedido }
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _vm._v(" Salvar\n      ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "warning", size: "sm" },
                      on: { click: _vm.deletePedido }
                    },
                    [
                      _c("i", { staticClass: "fas fa-trash-alt" }),
                      _vm._v(" Deletar\n      ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalEdit = false
                        }
                      }
                    },
                    [_vm._v("\n        Cancelar\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalEdit,
            callback: function($$v) {
              _vm.modalEdit = $$v
            },
            expression: "modalEdit"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-card-body",
                [
                  _c("b-row", [
                    _c("div", { staticClass: "fom-group col-md-6" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Quantidade")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "####",
                            expression: "'####'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quantidade,
                            expression: "quantidade"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.quantidade },
                        on: {
                          focus: _vm.searchProduto,
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.updatePedido.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.quantidade = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.estoqueDisponivelEdit > 0 || _vm.usarEstoque > 0
                      ? _c("div", { staticClass: "fom-group col-md-6" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Usar do Estoque")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "####",
                                expression: "'####'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.usarEstoque,
                                expression: "usarEstoque"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.usarEstoque },
                            on: {
                              focus: _vm.searchProduto,
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.updatePedido.apply(null, arguments)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.usarEstoque = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Disponível: " + _vm._s(_vm.estoqueDisponivelEdit)
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-md-12 container-btn text-center"
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Importar Pedidos", size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.pedidosImportados.length > 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: { click: _vm.addImportados }
                        },
                        [
                          _c("i", { staticClass: "fa fa-save" }),
                          _vm._v(" Salvar\n      ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalFileUpload = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalFileUpload,
            callback: function($$v) {
              _vm.modalFileUpload = $$v
            },
            expression: "modalFileUpload"
          }
        },
        [
          _c("b-card", [
            _c("div", { staticClass: "row" }, [
              _vm.pedidosImportados.length === 0
                ? _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Escolha o Arquivo")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { type: "file" },
                        on: { change: _vm.changeFile }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.sendFilePedidos.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-send" }),
                          _vm._v(" Enviar\n            ")
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pedidosImportados.length > 0
                ? _c("div", { staticClass: "col-md-12 resumo-importacao" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-responsive table-bordered table-striped"
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Produto")]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v("Quantidade")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.pedidosImportados, function(item, index) {
                            return _c("tr", { key: index }, [
                              _vm.produtos[item.codigo]
                                ? _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.produtos[item.codigo]
                                            ? _vm.produtos[item.codigo].nome
                                            : "Sem estoque"
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.produtos[item.codigo] &&
                              _vm.produtos[item.codigo].disponivel === true
                                ? _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.quantidade) +
                                        "\n                "
                                    )
                                  ])
                                : _vm.produtos[item.codigo] &&
                                  !_vm.produtos[item.codigo].disponivel
                                ? _c(
                                    "td",
                                    { staticClass: "text-danger text-center" },
                                    [_c("small", [_vm._v(" SEM ESTOQUE ")])]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.produtos[item.codigo]
                                ? _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.codigo) +
                                        "\n                "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.produtos[item.codigo]
                                ? _c(
                                    "td",
                                    { staticClass: "text-center text-danger" },
                                    [_vm._v("INDISPONIVEL")]
                                  )
                                : _vm._e()
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "",
            size: "lg",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("h4", [_vm._v(_vm._s(_vm.revendedoraSelecionada.label))])
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalPedidosAbertos = false
                        }
                      }
                    },
                    [_vm._v("Novo Pedido")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.cancelarEditaPedido()
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalPedidosAbertos,
            callback: function($$v) {
              _vm.modalPedidosAbertos = $$v
            },
            expression: "modalPedidosAbertos"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-row", { staticClass: "mb-3" }, [
                _c("h5", [
                  _vm._v(
                    "\n          Existe pedido(s) em aberto para esta revendedora na campanha atual !\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-table", {
                    attrs: {
                      items: _vm.pedidosAbertos,
                      fields: _vm.headerPedidosAbertos,
                      stacked: "md",
                      "head-variant": "dark",
                      hover: "",
                      responsive: "",
                      outlined: "",
                      bordered: "",
                      small: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(editar)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "warning" },
                                on: {
                                  click: function($event) {
                                    return _vm.editarPedido(row.item)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-edit" }),
                                _vm._v(" Editar\n            ")
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("h4", [
                    _c("span", [
                      _vm._v(
                        "Valor total do incentivo: R$\n          " +
                          _vm._s(_vm.saldoIncentivo.replace(".", ","))
                      )
                    ])
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.saveBrinde }
                    },
                    [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(" "),
                      _vm.totalPedidoIncentivo > 0
                        ? _c("span", [_vm._v("Salvar Pedido")])
                        : _c("span", [_vm._v("Salvar Pedido Sem Brinde")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalIncentivo = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalIncentivo,
            callback: function($$v) {
              _vm.modalIncentivo = $$v
            },
            expression: "modalIncentivo"
          }
        },
        [
          _vm._v(" "),
          _c(
            "b-card",
            [
              _c(
                "b-row",
                { staticClass: "mt-1 mb-1" },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-12" },
                    [
                      _c(
                        "b-alert",
                        { attrs: { variant: "success", show: "" } },
                        [_vm._v("Itens adicionados aqui, não são cobrados!")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { attrs: { "align-v": "end" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-4" },
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Produto")]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "form-control",
                        attrs: {
                          size: "sm",
                          placeholder: "Produto",
                          type: "search"
                        },
                        on: { keyup: _vm.searchProdutoIncentivo },
                        model: {
                          value: _vm.codigoProdutoIncentivo,
                          callback: function($$v) {
                            _vm.codigoProdutoIncentivo = $$v
                          },
                          expression: "codigoProdutoIncentivo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Quantidade")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { size: "sm", placeholder: "Quantidade" },
                        model: {
                          value: _vm.qtdProdutoIncentivo,
                          callback: function($$v) {
                            _vm.qtdProdutoIncentivo = $$v
                          },
                          expression: "qtdProdutoIncentivo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "success" },
                          on: {
                            click: function($event) {
                              return _vm.addIncentivo()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-plus" }),
                          _vm._v("\n            Adicionar")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", [
                    _vm.incentivoSelecionado
                      ? _c("span", [_c("h4", [_vm._v("Produto:")])])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.incentivoSelecionado
                      ? _c("span", { staticClass: "text-success" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.incentivoSelecionado.codigo) +
                              " -\n            " +
                              _vm._s(_vm.incentivoSelecionado.nome) +
                              " - R$\n            " +
                              _vm._s(
                                _vm.incentivoSelecionado.preco.replace(".", ",")
                              ) +
                              " cada\n          "
                          )
                        ])
                      : _c("span", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n            Produto não encontrado ou não encaixa na regra do incentivo\n          "
                          )
                        ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-table", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pedidosIncentivoTable.length > 0,
                        expression: "pedidosIncentivoTable.length > 0"
                      }
                    ],
                    attrs: {
                      striped: "",
                      hover: "",
                      fields: _vm.fields,
                      items: _vm.pedidosIncentivoTable
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(actions)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  size: "sm",
                                  title: "Remover Item",
                                  variant: "danger"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removerItemIncentivo(row.item)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-trash" })]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-row", { attrs: { "align-h": "end" } }, [
                _vm.totalPedidoIncentivo > 0
                  ? _c("span", [
                      _c("b", [
                        _vm._v(
                          "Total:\n            " +
                            _vm._s(
                              parseFloat(_vm.totalPedidoIncentivo)
                                .toFixed(2)
                                .replace(".", ",")
                            ) +
                            "\n          "
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-454a3d84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454a3d84","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedidos/create/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-454a3d84","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedidos/create/Main.vue
// module chunks = 2